// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiSlider-root.Slider {
    color: var(--palette-trovit-blue);
    height: 0.5rem;
}
.MuiSlider-rail.Slider__rail {
    color: var(--palette-whipe);
    height: 0.5rem;
    border-radius: 0px 5px 5px 0px;
}
.MuiSlider-track.Slider__track {
    height: 0.5rem;
    border-radius: 5px 0px 0px 5px;
    color: var(--palette-trovit-blue-opacity-20);
}
.MuiSlider-thumb.Slider__thumb {
    height: 1.5rem;
    width: 1.5rem;
    margin-top: -8px;
    margin-left: -12px;
}`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/input/Slider/Slider.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;IACd,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,8BAA8B;IAC9B,4CAA4C;AAChD;AACA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".MuiSlider-root.Slider {\n    color: var(--palette-trovit-blue);\n    height: 0.5rem;\n}\n.MuiSlider-rail.Slider__rail {\n    color: var(--palette-whipe);\n    height: 0.5rem;\n    border-radius: 0px 5px 5px 0px;\n}\n.MuiSlider-track.Slider__track {\n    height: 0.5rem;\n    border-radius: 5px 0px 0px 5px;\n    color: var(--palette-trovit-blue-opacity-20);\n}\n.MuiSlider-thumb.Slider__thumb {\n    height: 1.5rem;\n    width: 1.5rem;\n    margin-top: -8px;\n    margin-left: -12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
